export const ISSUE_VIEW_RAPIDBOARD_MARK_KEY = 'jira.frontend.classic-board.issue-view';
export const LOAD_START_ISSUE_VIEW_RAPIDBOARD_MARK_KEY =
	'LOAD_START_ISSUE_VIEW_RAPIDBOARD_MARK_KEY';
export const READY_START_ISSUE_VIEW_RAPIDBOARD_MARK_KEY =
	'READY_START_ISSUE_VIEW_RAPIDBOARD_MARK_KEY';
